module.exports = __webpack_public_path__ + "static/example_2_week_columns-8ee1e5f816d14bc9e0f18b8b578de8bc.png";